<template>
    <main-header />
    <sub-header v-if="step == 1" heading="Personalization" :subHeading="getStep()" :bgc="getHeaderBgc()"
    />
    
    <!-- Journey Modals -->
    <journey-modal
        :show="showSaveNotification"
        title="Progress Saved"
        message="Your personalization progress has been automatically saved to your account."
        icon="💾"
        type="success"
        :buttons="[{ text: 'Continue', action: 'close', class: 'btn-primary' }]"
        @close="showSaveNotification = false"
    />
    
    
    <div class="container-fluid">
        <div class="row justify-content-center" 
        v-if="loaded && step === 0">
            <!-- <profile-card-displayer /> -->
            <theme-swiper 
                :profiles="profiles"
                @profileSelected="receiveProfile" />
        </div>
        <div class="input__container" v-else-if="loaded && step === 1">
            <adaptive-information-input :dataByTyp="dataByTyp" :finalNext="next" @updateName="receivePet" @updatePetType="receivePetType" @updateInstagram="receiveInsta" @selectedfiles="receiveImages"/>
        </div>
        <div class="input__container" v-else-if="loaded && step === 2">
            <full-control
                :images="images"
                :profileType="this.profileType"
                :prodName="this.productName"
                :journeyId="this.productID"
                :initialSets="journey?.setProducts || journey?.fullControlSets"
                :initialState="journey?.fullControlState"
                @updateProduct="receiveProduct"
                @persistSets="persistFullControlSets"
                @persistState="persistFullControlState"
            />
        </div>
        <product-preloader v-else> Loading... </product-preloader>
    </div>
    <!-- <main-footer v-if="step !== 2"/> -->
</template>

<script>
import SubHeader from "@/components/SubHeader.vue";
import ProfileCard from "@/components/home_components/cards/ProfileCard.vue";
import ControlCard from "@/components/home_components/cards/ControlCard.vue";
import ProductPreloader from "@/components/preloaders/ProductPreloader.vue";
import InputCamp from "@/components/home_components/products/InputCamp.vue";
import ImageUploader from "@/components/home_components/products/ImageUploader.vue";
import TextCamp from "@/components/home_components/products/TextCamp.vue";
import SelectorCamp from "@/components/home_components/products/SelectorCamp.vue";
import MainHeader from "@/components/MainHeader.vue";
import MainFooter from "@/components/MainFooter.vue";
import ActionButton from "@/components/ActionButton.vue";
import Swal from 'sweetalert2';
import PersonalizationButton from "@/components/home_components/products/PersonalizationButton.vue";
import ImageSelector from "@/components/home_components/products/ImageSelector.vue";

import MediumControl from "@/components/home_components/products/MediumControl.vue";
import FullControl from "@/components/home_components/products/FullControl.vue";
import InfoDisplayer from "@/components/home_components/products/InfoDisplayer.vue"
import AdaptiveInformationInput from "@/components/home_components/AdaptiveInformationInput.vue";
import ProfileCardDisplayer from "@/components/home_components/ProfileCardDisplayer.vue";
// import ControlCardDisplayer from "@/components/home_components/ControlCardDisplayer.vue";

import Love from "@/components/animations/HeartAnimation.vue"
import Gifting from "@/components/animations/Gifting.vue"
import Memorial from "@/components/animations/StarAnimation.vue"
import Away from "@/components/animations/AwayHome.vue"
import WildLove from "@/components/animations/Wild.vue"

import { mapActions, mapState, mapGetters } from "vuex";
import ThemeSwiper from "@/components/profile/ThemeSwiper.vue";
import { uploadImages, uploadItemImages } from "@/firebase/storageService";
import { auth } from "@/firebase/init";
import JourneyModal from "@/components/JourneyModal.vue";
import { createJourney, createProductItem, addPersonalizationToProduct, updateJourneyMetadata } from "@/models/JourneyModel";
import { syncJourney, loadJourney, deleteJourney as deleteJourneyPersistence } from "@/services/journeyPersistence";

export default {
    name: "ShopView",
    components: {
        SubHeader,
        ProfileCard,
        MainHeader,
        MainFooter,
        ControlCard,
        InputCamp,
        ImageUploader,
        SelectorCamp,
        TextCamp,
        ActionButton,
        PersonalizationButton,
        ImageSelector,
        MediumControl,
        FullControl,
        InfoDisplayer,
        "product-preloader": ProductPreloader,
        AdaptiveInformationInput,
        ProfileCardDisplayer,
        // ControlCardDisplayer,
        Love,
        Gifting,
        Memorial,
        Away,
        WildLove,
        ThemeSwiper,
        JourneyModal
    },
    data() {
        return {
            product: "",
            productName: "",
            profiles: [],
            controls: [],
            options: [],
            inputs: [],
            page: 1,
            loaded: false,
            total: 0,
            step: 0,

            //Profile type - Love, Gifting, etc.
            profileType: "",
            //PetType
            petName: "",
            petType: "",
            instagram: "",

            //Images
            images: [],

            //Coments
            coments: "",

            //Theme
            theme: "",

            //Product - Accompania, Everlast, Artistico objects
            product: {},

            productID: "",
            productPrice: 0,
            
            // Modal states
            showSaveNotification: false,
            
            // New journey structure
            currentJourney: null,
        };
    },
    async created() {
        this.getInputs();
        this.getProfiles();
        this.getControls();
        this.getOptions();
        
        const rawId = this.$route.params.id;
        const baseId = String(rawId).split('-')[0];
        const isComposite = String(rawId).includes('-');
        
        // Try to load existing journey from cookies/Firebase
        let existingJourney = null;
        if (isComposite) {
            existingJourney = await loadJourney(rawId);
        }
        
        // Validate that existing journey has actual progress
        const hasProgress = existingJourney && (
            (existingJourney.step && existingJourney.step > 0) ||
            (existingJourney.setProducts && existingJourney.setProducts.length > 0) ||
            existingJourney.petName ||
            existingJourney.profileType
        );
        
        if (existingJourney && hasProgress) {
            // Resume existing journey
            this.productID = rawId;
            this.currentJourney = existingJourney;
            this.step = Math.min(existingJourney.step || 0, 2);
            this.getProductName(baseId);
            
            // Restore fields from journey
            this.profileType = existingJourney.profileType || this.profileType;
            this.petName = existingJourney.petName || this.petName;
            this.petType = existingJourney.petType || this.petType;
            this.instagram = existingJourney.instagram || this.instagram;
            this.coments = existingJourney.comments || this.coments;
            this.theme = existingJourney.theme || this.theme;
            
            console.log('Resumed existing journey:', this.productID);
        } else {
            // Start a new journey
            this.productID = `${baseId}-${Date.now()}`;
            this.getProductName(baseId);
            
            // Create new journey structure
            const user = auth.currentUser;
            this.currentJourney = createJourney(
                this.productID,
                user ? user.uid : 'anonymous',
                'set',
                '' // Will be set when product name is loaded
            );
            
            console.log('Started new journey:', this.productID);
        }
    },
    methods: {
        ...mapActions(["add_to_cart", "set_journey_progress", "complete_journey"]),
        
        
        showProgressSavedNotification() {
            this.showSaveNotification = true;
            setTimeout(() => {
                this.showSaveNotification = false;
            }, 3000);
        },
        
        resetLocalState() {
            this.step = 0;
            this.profileType = "";
            this.petName = "";
            this.petType = "";
            this.instagram = "";
            this.images = [];
            this.coments = "";
            this.theme = "";
            this.product = {};
            this.productName = "";
            this.productPrice = 0;
        },
        getProfiles() {
            this.loaded = false;
            fetch("/data/personalization/profile.json")
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    this.profiles = data.results.map((product) => {
                        product.images[0] = product.images[0];

                        return product;
                    });
                    this.total = Math.ceil(data.results.length / 12);
                    this.loaded = true;
                })
                .catch((err) => {
                    console.log(err);
                    this.loaded = false;
                });
        },
        getMessage(){
            return "Your current theme is "+this.profileType + ", would you like to specify anything  about your relationship and love for our artist's inspiration? Alternatively, you can enter two specific messages.";
        },
        getControls() {
            this.loaded = false;
            fetch("/data/personalization/control.json")
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    this.controls = data.results.map((product) => {
                        product.images[0] = product.images[0].replace(
                            "http",
                            "https"
                        );

                        return product;
                    });
                    this.total = Math.ceil(data.results.length / 12);
                    this.loaded = true;
                })
                .catch((err) => {
                    console.log(err);
                    this.loaded = false;
                });
        },
        updateImageSources(data) {
            Object.keys(data).forEach(categoryKey => {
                const category = data[categoryKey];
                category.forEach(item => {
                    if (item.props.img1src) {
                        try {
                            item.props.img1src = require(`${item.props.img1src}`);
                        } catch (e) {
                            console.error(`Cannot find module '@/assets/journey/${item.props.img1src}'`);
                        }
                    }
                    if (item.props.img2src) {
                        try {
                            item.props.img2src = require(`${item.props.img2src}`);
                        } catch (e) {
                            console.error(`Cannot find module '@/assets/journey/${item.props.img2src}'`);
                        }
                    }
                });
            });
            return data;
        },
        getInputs(){
            this.loaded = false;
            fetch("/data/personalization/informationinput.json")
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    // this.inputs = this.updateImageSources(data)
                    this.inputs = data;
                    this.loaded = true;
                })
                .catch((err) => {
                    console.log(err);
                    this.loaded = false;
                });
        }, getProductName(productId) {
            fetch("/data/products.json")
                .then((response) => response.json())
                .then((data) => {
                    const result = data.results.find(item => item._id === productId);
                    if (result) {
                        this.productName = result.name;
                        this.productPrice = result.price;
                        console.log(result.name);
                        
                        // Update journey with product name
                        if (this.currentJourney) {
                            this.currentJourney.setName = result.name;
                            this.syncJourneyData();
                        }
                        
                        // Also update Vuex for backward compatibility
                        if (!this.getJourneyByProductId(this.productID)) {
                            this.set_journey_progress({ productId: this.productID, productName: this.productName, step: 0, isComplete: false });
                        }
                    } else {
                        console.log("error fetching product name with product ID: " + this.productID);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 
        getOptions() {
            this.loaded = false;
            fetch("/data/personalization/petsTypes.json")
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    this.options = data.pets
                    this.loaded = true;
                })
                .catch((err) => {
                    console.log(err);
                    this.loaded = false;
                });
        },
        fetchNewPage(page) {
            this.page = page;
            this.getProducts();
            window.scrollTo(0, 0);
        },
        receiveProfile(profile) {
            console.log("profile: ", profile);
            this.profileType = profile;
            
            // Update journey
            if (this.currentJourney) {
                this.currentJourney.profileType = profile;
                this.syncJourneyData();
            }
            
            // Also update Vuex for backward compatibility
            this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false, profileType: this.profileType });
            this.next();
        },
        receivePet(pet) {
            console.log(pet);
            this.petName = pet;
            
            // Update journey
            if (this.currentJourney) {
                this.currentJourney.petName = pet;
                this.syncJourneyData();
            }
        },
        async receiveImages(images) {
            try {
                // Store the File objects temporarily for preview
                this.images = images;
                
                // Get current user
                const user = auth.currentUser;
                if (!user) {
                    console.warn('User not logged in, cannot upload images');
                    this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false, images: this.images });
                    return;
                }
                
                // Upload images to Firebase Storage and get URLs
                const imageUrls = await uploadImages(images, user.uid, this.productID);
                
                // Store both File objects (for preview) and URLs (for persistence)
                this.images = images.map((file, index) => ({
                    file: file,
                    url: imageUrls[index],
                    name: file.name,
                    size: file.size
                }));
                
                // Save URLs to journey progress
                await this.set_journey_progress({ 
                    productId: this.productID, 
                    productName: this.productName, 
                    step: this.step, 
                    isComplete: false, 
                    images: this.images,
                    imageUrls: imageUrls // Store URLs separately for easy access
                });
                
                // Show save notification
                this.showProgressSavedNotification();
            } catch (error) {
                console.error('Error uploading images:', error);
                // Fallback to storing File objects only
                this.images = images;
                await this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false, images: this.images });
            }
        },
        receiveInsta(insta) {
            console.log(insta);
            this.instagram = insta;
            
            // Update journey
            if (this.currentJourney) {
                this.currentJourney.instagram = insta;
                this.syncJourneyData();
            }
            
            this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false, instagram: this.instagram });
        },
        receivePetType(petType) {
            console.log(petType);
            this.petType = petType;
            
            // Update journey
            if (this.currentJourney) {
                this.currentJourney.petType = petType;
                this.syncJourneyData();
            }
            
            this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false, petType: this.petType });
        },
        receiveComents(coments) {
            console.log(coments);
            this.coments = coments;
            
            // Update journey
            if (this.currentJourney) {
                this.currentJourney.comments = coments;
                this.syncJourneyData();
            }
            
            this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false, comments: this.coments });
        },
        receiveTheme(theme) {
            console.log(theme);
            this.theme = theme;
            
            // Update journey
            if (this.currentJourney) {
                this.currentJourney.theme = theme;
                this.syncJourneyData();
            }
            
            this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false, theme: this.theme });
        },
        receiveProduct(product) {
            console.log(product);
            this.product = product;
            this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false, product: this.product });
            this.next();

        },
        persistFullControlSets(sets) {
            try {
                console.log('🔄 STEP 2 - persistFullControlSets() received sets:', sets.length);
                
                // Check what we received
                const receivedWithData = sets.filter(s => s.personalization?.length > 0);
                console.log(`   Received ${receivedWithData.length}/${sets.length} products with personalization`);
                
                // Update journey with product sets (NEW FORMAT)
                if (this.currentJourney && Array.isArray(sets)) {
                    // Clean sets: keep personalization array, userSelections, but remove components
                    const cleanedSets = sets.map(set => ({
                        name: set.name,
                        isComplete: set.isComplete || false,
                        showComponent: set.showComponent,
                        professional: set.professional,
                        personalizationType: set.personalizationType,
                        // USER DATA - This is what we persist
                        personalization: set.personalization || []
                        // Note: userUploadedImageUrls and userSelections are deprecated
                        // All data is now in the personalization array
                    }));
                    
                    const cleanedWithData = cleanedSets.filter(s => s.personalization?.length > 0);
                    console.log(`   After cleaning: ${cleanedWithData.length}/${cleanedSets.length} products with personalization`);
                    
                    this.currentJourney.setProducts = cleanedSets;
                    this.syncJourneyData();
                }
                
                // Also save to Vuex (OLD FORMAT for backward compatibility)
                console.log('   Saving to Vuex...');
                this.set_journey_progress({ 
                    productId: this.productID, 
                    productName: this.productName, 
                    step: this.step, 
                    isComplete: false, 
                    fullControlSets: sets,
                    setProducts: this.currentJourney?.setProducts // Also save new format
                });
            } catch (e) {
                console.error('Failed to persist fullControlSets', e);
            }
        },
        persistFullControlState(state) {
            try {
                this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false, fullControlState: state });
            } catch (e) {
                console.error('Failed to persist fullControlState', e);
            }
        },
        async syncJourneyData() {
            if (!this.currentJourney) return;
            
            try {
                // Update journey metadata
                this.currentJourney.step = this.step;
                this.currentJourney.updatedAt = Date.now();
                
                // Sync to cookies and Firebase
                await syncJourney(this.currentJourney);
                console.log('Journey synced:', this.productID);
            } catch (error) {
                console.error('Error syncing journey:', error);
            }
        },
        next() {
            if (this.step === 2 ) {
                if (this.profileType === "") {
                    Swal.fire({
                        title: 'Error',
                        text: 'Please select a theme',
                        icon: 'error',
                    });
                    return;
                }
            }

            this.step = this.step + 1;
            console.log(this.step);
            
            // Update journey
            if (this.currentJourney) {
                this.currentJourney.step = this.step;
                this.syncJourneyData();
            }
            
            // persist progress
            this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false });
            if (this.step === 3) {
                // Extract image URLs from images array
                const imageUrls = this.images.map(img => img.url || img).filter(Boolean);
                
                let item =          {
                    "_id":  this.productID + Math.random().toString(36),
                    "productId": this.productID,
                    "brand": this.productName,
                    "profile": this.profileType,
                    "petName": this.petName,
                    "petSpecies": this.petType,
                    "insta": this.instagram,
                    "images": this.images,
                    "imageUrls": imageUrls, // Store URLs separately for easy access
                    "comments": this.coments,
                    "theme": this.theme,
                    // "product": this.product,
                    "price": this.productPrice,
                    "currency": "$",
                    "quantity": 1,
                    "product": this.productName,
                    "journeyType": "set",
                    "fullControlSets": this.journey?.fullControlSets || []
                }
                console.log(item);
                this.add_to_cart(item);
                this.complete_journey(this.productID);
                this.$router.push("/cart");
                return;
            }
        },
        back() {
            this.step = this.step - 1;
            
            // Update journey
            if (this.currentJourney) {
                this.currentJourney.step = this.step;
                this.syncJourneyData();
            }
            
            this.set_journey_progress({ productId: this.productID, productName: this.productName, step: this.step, isComplete: false });
        },
        getStep() {
            if (this.step == 0)
                return "Personalize your set to your style";
            if (this.step == 1)
                return "Tell us about your oxytocin!";
            if (this.step == 2)
                return "Almost there!";
            return `Personalize your set to your style`;
        },
        getHeaderBgc() {
            let bgc_map = {
                "animal-love" : "#bc9c22",
                "gift": "#f19586",
                "love": "#e5a7a1",
                "temporary-separation": "#957548",
                "memorialize": "#c2dace",
            }
            if (this.profileType!=null & this.profileType in bgc_map)
                return bgc_map[this.profileType];
            else
                return "var(--dim-blue)";
        }
    },
    beforeRouteLeave(to, from, next) {
        next();
    },
    async beforeRouteUpdate(to, from, next) {
        const rawId = to.params.id;
        const baseId = String(rawId).split('-')[0];
        const isComposite = String(rawId).includes('-');
        
        // Try to load existing journey
        let existingJourney = null;
        if (isComposite) {
            existingJourney = await loadJourney(rawId);
        }
        
        if (existingJourney) {
            // Resume existing journey
            this.productID = rawId;
            this.currentJourney = existingJourney;
            this.step = Math.min(existingJourney.step || 0, 2);
            this.getProductName(baseId);
            
            // Restore fields
            this.profileType = existingJourney.profileType || this.profileType;
            this.petName = existingJourney.petName || this.petName;
            this.petType = existingJourney.petType || this.petType;
            this.instagram = existingJourney.instagram || this.instagram;
            this.coments = existingJourney.comments || this.coments;
            this.theme = existingJourney.theme || this.theme;
        } else {
            // New product → start from step 0
            this.resetLocalState();
            this.productID = `${baseId}-${Date.now()}`;
            this.getProductName(baseId);
            
            // Create new journey
            const user = auth.currentUser;
            this.currentJourney = createJourney(
                this.productID,
                user ? user.uid : 'anonymous',
                'set',
                ''
            );
        }
        next();
    },
    computed: {
        ...mapGetters(["getJourneyByProductId"]),
        journey() {
            // Return new journey structure if available, otherwise fall back to Vuex
            return this.currentJourney || this.getJourneyByProductId(this.productID) || {};
        },
        dataByTyp() {
            let originalData = this.inputs[this.profileType];
            originalData = originalData.filter((item) => item.props.question !== "Enter your pet social media");
            originalData = originalData.filter((item) => item.props.question !== "Upload 10 images");
            originalData = originalData.filter((item) => item.props.disclaimer == null);
            return originalData;
            // return this.inputs[this.profileType];
        },
    },
    watch: {
    // Watch the 'step' data property
    step(newValue, oldValue) {
      // Scroll to the top of the page whenever 'step' changes
      window.scrollTo(0, 0);
    }
  },
};
</script>

<style scoped>
.btn {
    border: none;
    background-color: #f2f2f2;
    padding-inline: 20px;
    height: 40px;
    border: 2px solid var(--grey-2);
    font-size: 1.7rem;
    margin-inline: 5px;
    cursor: pointer;
}

.swal2-popup {
    font-size: 1.6rem !important;
    font-family: Georgia, serif;
}

.back-btn,
.next-btn {
    background-color: #f2f2f2;
    color: black;
}

.btn:hover {
    background-color: #083e46;
    border-color: #083e46;
    color: white;
}

.btn-active {
    background-color: #083e46;
    color: white;
    border-color: #083e46;
}

.pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2rem 0;
}

.input__container {
    text-align: center;
    border-radius: 8px;
    margin: 0 auto;
    width: 100%;
}

.container-fluid {
    padding-left: 0;
    padding-right: 0;
}

.container-fluid div#animations {
    overflow: hidden;
    border-radius: 0px;
}

.actionButton {
    background-color: var(--dark-green);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 1.7rem;
    cursor: pointer;
    margin-top: 20px;
}
.no-container {
  width: 100%;
  max-width: none;
  padding-left: 0;
  padding-right: 0;
}
</style>

